/* tslint:disable */
/* eslint-disable */
/**
 * Lumen Failure Management API
 * <h5>ToDo: API description</h5>
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    SlenderTownVm,
    SlenderTownVmFromJSON,
    SlenderTownVmFromJSONTyped,
    SlenderTownVmToJSON,
} from './';

/**
 * 
 * @export
 * @interface SlenderTownVmPaginatedSearchResponse
 */
export interface SlenderTownVmPaginatedSearchResponse {
    /**
     * 
     * @type {Array<SlenderTownVm>}
     * @memberof SlenderTownVmPaginatedSearchResponse
     */
    items?: Array<SlenderTownVm> | null;
    /**
     * 
     * @type {number}
     * @memberof SlenderTownVmPaginatedSearchResponse
     */
    totalCount?: number;
    /**
     * 
     * @type {number}
     * @memberof SlenderTownVmPaginatedSearchResponse
     */
    from?: number;
    /**
     * 
     * @type {number}
     * @memberof SlenderTownVmPaginatedSearchResponse
     */
    to?: number;
    /**
     * 
     * @type {number}
     * @memberof SlenderTownVmPaginatedSearchResponse
     */
    page?: number;
    /**
     * 
     * @type {number}
     * @memberof SlenderTownVmPaginatedSearchResponse
     */
    size?: number;
}

export function SlenderTownVmPaginatedSearchResponseFromJSON(json: any): SlenderTownVmPaginatedSearchResponse {
    return SlenderTownVmPaginatedSearchResponseFromJSONTyped(json, false);
}

export function SlenderTownVmPaginatedSearchResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): SlenderTownVmPaginatedSearchResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'items': !exists(json, 'items') ? undefined : (json['items'] === null ? null : (json['items'] as Array<any>).map(SlenderTownVmFromJSON)),
        'totalCount': !exists(json, 'totalCount') ? undefined : json['totalCount'],
        'from': !exists(json, 'from') ? undefined : json['from'],
        'to': !exists(json, 'to') ? undefined : json['to'],
        'page': !exists(json, 'page') ? undefined : json['page'],
        'size': !exists(json, 'size') ? undefined : json['size'],
    };
}

export function SlenderTownVmPaginatedSearchResponseToJSON(value?: SlenderTownVmPaginatedSearchResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'items': value.items === undefined ? undefined : (value.items === null ? null : (value.items as Array<any>).map(SlenderTownVmToJSON)),
        'totalCount': value.totalCount,
        'from': value.from,
        'to': value.to,
        'page': value.page,
        'size': value.size,
    };
}


